import {useState, useEffect} from 'react'

const useIsMobile = (breakpoint = 767) => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < breakpoint)
        }

        // Check on mount
        checkIsMobile()

        // Add event listener
        window.addEventListener('resize', checkIsMobile)

        // Cleanup
        return () => window.removeEventListener('resize', checkIsMobile)
    }, [breakpoint])

    return isMobile
}

export default useIsMobile
